import { render, staticRenderFns } from "./PageSetClass.vue?vue&type=template&id=5c615ab1&scoped=true&"
import script from "./PageSetClass.vue?vue&type=script&lang=js&"
export * from "./PageSetClass.vue?vue&type=script&lang=js&"
import style0 from "./PageSetClass.vue?vue&type=style&index=0&id=5c615ab1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c615ab1",
  null
  
)

export default component.exports